import { createTheme } from '@mui/material/styles';
import { colors } from '../styles/colors.js';
import shippoTheme from '../styles/shippoTheme.js';

const baseBody = {
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '1rem',
    lineHeight: 1.5,
    color: colors.text.default,
};
const baseCaption = {
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '0.75rem',
    lineHeight: 1.37,
    color: colors.text.default,
};
const baseLink = {
    fontWeight: 400,
    fontSize: '1rem',
    lineHeight: 1.5,
    textDecoration: 'underline',
    color: colors.accent.foreground.success,
};
const extendedTypographyOptions = {
    h1: {
        fontWeight: 500,
        fontStyle: 'normal',
        fontSize: '1.75rem',
        lineHeight: 1.2,
        color: colors.text.default,
    },
    h2: {
        fontWeight: 500,
        fontStyle: 'normal',
        fontSize: '1.25rem',
        lineHeight: 1.2,
        color: colors.text.default,
    },
    h3: {
        fontStyle: 'normal',
        fontWeight: 500,
        fontSize: '0.75rem',
        lineHeight: 1.2,
        textTransform: 'uppercase',
        color: colors.text.default,
    },
    body: baseBody,
    bodyEmphasized: Object.assign(Object.assign({}, baseBody), { fontWeight: 500 }),
    bodyItalic: Object.assign(Object.assign({}, baseBody), { fontStyle: 'italic' }),
    caption: Object.assign({}, baseCaption),
    captionEmphasized: Object.assign(Object.assign({}, baseCaption), { fontWeight: 500 }),
    captionItalic: Object.assign(Object.assign({}, baseCaption), { fontStyle: 'italic' }),
    linkWhiteBg: baseLink,
    linkWhiteBgEmphasized: Object.assign(Object.assign({}, baseLink), { fontWeight: 500 }),
    captionLinkWhiteBg: Object.assign(Object.assign({}, baseCaption), { lineHeight: 1.5, textDecoration: 'underline', color: colors.accent.foreground.success }),
    captionLinkWhiteBgEmphasized: Object.assign(Object.assign({}, baseCaption), { lineHeight: 1.5, fontWeight: 500, color: colors.accent.foreground.success }),
    linkColorBg: Object.assign(Object.assign({}, baseLink), { color: colors.text.default }),
    linkColorBgEmphaszed: Object.assign(Object.assign({}, baseLink), { color: colors.text.default, fontWeight: 500 }),
    captionLinkColorBg: Object.assign(Object.assign({}, baseCaption), { color: colors.text.default, lineHeight: 1.5, textDecoration: 'underline' }),
    captionLinkColorBgEmphasized: Object.assign(Object.assign({}, baseCaption), { color: colors.text.default, lineHeight: 1.5, fontWeight: 500 }),
};
var typographyTheme = createTheme(shippoTheme, {
    palette: {
        primary: {
            main: colors.text.default,
            dark: colors.text.default,
        },
        secondary: {
            main: colors.text.default,
            dark: colors.text.default,
        },
        green: {
            main: colors.accent.foreground.success,
            dark: colors.accent.foreground.success,
        },
    },
    typography: extendedTypographyOptions,
});

export { typographyTheme as default, extendedTypographyOptions };
//# sourceMappingURL=Typography.theme.js.map
